export default {
  getHomepageCourses: (state) => state.homepageCourses,
  getCourseList: (state) => state.courses,
  getCourse: (state) => state.course,
  getTrustedCompanies: (state) => state.trustedCompanies,
  getTestimonials: (state) => state.testimonials,
  getEmpoweringLanguage: (state) => state.empoweringLanguage,
  gethomeCaseStudies: (state) => state.homeCaseStudies,
  getHomepageInsights: (state) => state.homepageInsights,
  getHomePageHeader: (state) => state.homePageHeader,
  getCoursesHeader: (state) => state.coursesHeader,
  getUnderstandingCourses: (state) => state.understandingCourses,
  getIncludedInOurCourses: (state) => state.includedInOurCourses,
  getComprehensiveCourses: (state) => state.comprehensiveCourses,
  getBreadcrumbs: (state) => state.breadcrumbs,
  getArticles: (state) => state.articles,
  getArticle: (state) => state.article,
  getK12Header: (state) => state.K12Header,
  getOurSolutionsHome: (state) => state.ourSolutionsHome,
  getOurSolutionsK12: (state) => state.ourSolutionsK12,
  getOurSolutionsIB: (state) => state.ourSolutionsIB,
  getOurSolutionsHigherEd: (state) => state.ourSolutionsHigherEd,
  getOurSolutionsPublic: (state) => state.ourSolutionsPublic,
  getOurSolutionsPrivate: (state) => state.ourSolutionsPrivate,
  getOurSolutionsIndividual: (state) => state.ourSolutionsIndividual,
  getOurSolutionsCorporate: (state) => state.ourSolutionsCorporate,
  getOurSolutionsCurriculum: (state) => state.ourSolutionsCurriculum,
  getYourChallengesK12: (state) => state.yourChallengesK12,
  getYourChallengesIB: (state) => state.yourChallengesIB,
  getYourChallengesHigherEducation: (state) =>
    state.yourChallengesHigherEducation,
  getYourChallengesPublic: (state) => state.yourChallengesPublic,
  getYourChallengesPrivate: (state) => state.yourChallengesPrivate,
  getYourChallengesIndividual: (state) => state.yourChallengesIndividual,
  getYourChallengesCorporate: (state) => state.yourChallengesCorporate,
  getCollaborationsTimelineK12: (state) => state.collaborationsTimelineK12,
  getCollaborationsTimelineIB: (state) => state.collaborationsTimelineIB,
  getCollaborationsTimelineHigherEducation: (state) =>
    state.collaborationsTimelineHigherEducation,
  getCollaborationsTimelinePublic: (state) =>
    state.collaborationsTimelinePublic,
  getCollaborationsTimelinePrivate: (state) =>
    state.collaborationsTimelinePrivate,
  getCollaborationsTimelineIndividuals: (state) =>
    state.collaborationsTimelineIndividuals,
  getCollaborationsTimelineCorporate: (state) =>
    state.collaborationsTimelineCorporate,
  getCurriculumTimelineHeritage: (state) => state.curriculumTimelineHeritage,
  geteBooks: (state) => state.eBooks,
  geteBook: (state) => state.eBook,
  getCaseStudies: (state) => state.caseStudies,
  getCaseStudy: (state) => state.caseStudy,
  getK12Providers: (state) => state.k12Providers,
  getK12Provider: (state) => state.k12Provider,
  getK12ProviderHeader: (state) => state.K12ProviderHeader,
  getCookiePolicy: (state) => state.cookiePolicy,
  getIBHeader: (state) => state.IBHeader,
  getHigherEducationHeader: (state) => state.higherEducationHeader,
  getPrivateSectorHeader: (state) => state.privateSectorHeader,
  getIndividualsHeader: (state) => state.individualsHeader,
  getCurriculumHeader: (state) => state.curriculumHeader,
  getParentsHeader: (state) => state.parentsHeader,
  getCorporateSectorHeader: (state) => state.corporateSectorHeader,
  getNonProfitsHeader: (state) => state.nonProfitsHeader,
  getPricingPlans: (state) => state.pricingPlans,
  getfrequentlyAskedQuestions: (state) => state.frequentlyAskedQuestions,
  getAboutUsHeader: (state) => state.AboutUsHeader,
  getMissionsAndVisions: (state) => state.missionsAndVisions,
  getMeetOurTeam: (state) => state.meetOurTeam,
  getResourcesHeader: (state) => state.resourcesHeader,
  getGuides: (state) => state.guides,
  getGuide: (state) => state.guide,
  getEvents: (state) => state.events,
  getEvent: (state) => state.event,
  getConsent: (state) => state.consent,
  getNotification: (state) => state.notification,
  getDialog: (state) => state.dialog,
  getProgress: (state) => state.progress,
  getIndividualCourses: (state) => state.individualCourses,
  getIndividualSolutions: (state) => state.individualSolutions,
  getCollaborationsTimelineIndividual: (state) =>
    state.collaborationsTimelineIndividual,
  getFitForYou: (state) => state.fitForYou,
  getIndividualPricing: (state) => state.individualPricing,
  getTryComligo: (state) => state.tryComligo,
  getParentSolutions: (state) => state.parentSolutions,
  getCollaborationsTimelineParents: (state) =>
    state.collaborationsTimelineParents,
  getParentSolutionsTable: (state) => state.parentSolutionsTable,
  getParentTestimonials: (state) => state.parentTestimonials,
  getParentsFAQ: (state) => state.parentsFAQ,
  getHeritageFAQ: (state) => state.heritageFAQ,
  getProfessionalHeader: (state) => state.professionalHeader,
  getDayToDaySpanish: (state) => state.dayToDaySpanish,
  getCollaborationsTimelineProfessional: (state) =>
    state.collaborationsTimelineProfessional,
  getproSolutionsTable: (state) => state.proSolutionsTable,
  getIndividualSolutionsTable: (state) => state.individualSolutionsTable,
  getProTestimonials: (state) => state.proTestimonials,
  getSocialProof: (state) => state.socialProof,
  getLearningHubHeader: (state) => state.learningHubHeader,
  getLearningHubs: (state) => state.learningHubs,
  getLearningHub: (state) => state.learningHub,
  getNoviceQuestions: (state) => state.noviceQuestions,
  getIntermediateQuestions: (state) => state.intermediateQuestions,
  getAdvancedQuestions: (state) => state.advancedQuestions,
  getFullName: (state) => state.fullName,
  getEmail: (state) => state.email,
  getSelected: (state) => state.selected,
  getPrivacy: (state) => state.privacy,
  getAge: (state) => state.age,
  getHotSite: (state) => state.hotSite,
  getHeritageSpeakersHeader: (state) => state.heritageSpeakersHeader,
  getHeritageSolutions: (state) => state.heritageSolutions,
  getCollaborationsTimelineHeritage: (state) =>
    state.collaborationsTimelineHeritage,
  getHeritageSolutionsTable: (state) => state.heritageSolutionsTable,
  getHeritageTestimonials: (state) => state.heritageTestimonials,
  getCurriculumTestimonials: (state) => state.curriculumTestimonials,
  getPrices: (state) => state.prices,
  getCurriculumProducts: (state) => state.curriculumProducts,
  getProduct: (state) => state.product,
  getPurchaseTutorial: (state) => state.purchaseTutorial,
  getCart: (state) => state.cart,
  getSignedIn: (state) => state.signedIn,
  getQuoteDetails: (state) => state.quoteDetails,
  getError: (state) => state.error,
  getLastURL: (state) => state.lastURL,
  getShowForgotPassword: (state) => state.showForgotPassword,
  getShowResetPassword: (state) => state.showResetPassword,
  getShowQuotePO: (state) => state.showQuotePO,
  getLicenses: (state) => state.licenses,
  getProductDetails: (state) => state.productDetails,
  getOrders: (state) => state.orders,
};
